"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetGroup = void 0;
var TargetGroup;
(function (TargetGroup) {
    TargetGroup["Male"] = "male";
    TargetGroup["Female"] = "female";
    TargetGroup["Couple"] = "couple";
})(TargetGroup = exports.TargetGroup || (exports.TargetGroup = {}));
//# sourceMappingURL=targetGroup.js.map